import { render, staticRenderFns } from "./PeasantsReport.vue?vue&type=template&id=c99094dc"
import script from "./PeasantsReport.vue?vue&type=script&lang=js"
export * from "./PeasantsReport.vue?vue&type=script&lang=js"
import style0 from "./PeasantsReport.vue?vue&type=style&index=0&id=c99094dc&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports